import { BreakpointObserver } from '@angular/cdk/layout';
import { computed, DOCUMENT, inject, Injectable, signal } from '@angular/core';
import { LogsService } from '@shared/services/logs';
import { breakpoints } from '@shared/services/responsive/config';
import { tap } from 'rxjs/operators';

export type BreakpointAvailable = 'mobile' | 'desktop';

@Injectable({ providedIn: 'root' })
export class ResponsiveService {
  readonly breakpoints = signal<BreakpointAvailable>('mobile');
  readonly isMobile = computed(() => this.breakpoints() === 'mobile');
  readonly isDesktop = computed(() => this.breakpoints() === 'desktop');
  readonly previousBreakpoints = signal<BreakpointAvailable>(null!);
  readonly devicePixelRatio = inject(DOCUMENT).defaultView?.devicePixelRatio ?? 1;
  private readonly displayNameMap = new Map<string, BreakpointAvailable>([
    [breakpoints.mobile, 'mobile'],
    [breakpoints.desktop, 'desktop'],
  ]);
  private readonly logs = inject(LogsService);

  constructor() {
    inject(BreakpointObserver)
      .observe([breakpoints.mobile, breakpoints.desktop])
      .pipe(
        tap((result) => {
          for (const query of Object.keys(result.breakpoints)) {
            if (result.breakpoints[query]) {
              this.previousBreakpoints.set(this.breakpoints());
              this.breakpoints.set(this.displayNameMap.get(query) ?? 'mobile');
              this.logs.debug(`ResponsiveService`, `The breakpoint has been set on "${this.breakpoints()}"`);
            }
          }
        })
      )
      .subscribe();
  }
}
